import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { AtivacaoSectionCardComponent } from '@shared/components/ativacao-section-card/ativacao-section-card.component';
import { FormulaCatalogoItemStruct } from '@shared/services/structs/formula/formula-catalogo-item.struct';
import { RegraTributariaMonoPadraoSectionComponent } from './sections/mono-padrao-section/regra-tributaria-mono-padrao-section.component';
import { RegraTributariaMonoRetencaoSectionComponent } from './sections/mono-retencao-section/regra-tributaria-mono-retencao-section.component';
import { RegraTributariaMonoRetidaSectionComponent } from './sections/mono-retida-section/regra-tributaria-mono-retida-section.component';
import { RegraTributariaMonoDiferimentoSectionComponent } from './sections/mono-diferimento-section/regra-tributaria-mono-diferimento-section.component';

const minimoZero = Validators.min(0);

/** Aba Tributação Monofásica: ativação do tributo e as 4 seções (padrão, retenção, retida ant. e diferimento). */
@Component({
    selector: 'app-regra-tributaria-trib-mono-tab',
    standalone: true,
    imports: [
        CommonModule,
        AtivacaoSectionCardComponent,
        RegraTributariaMonoPadraoSectionComponent,
        RegraTributariaMonoRetencaoSectionComponent,
        RegraTributariaMonoRetidaSectionComponent,
        RegraTributariaMonoDiferimentoSectionComponent,
    ],
    templateUrl: './regra-tributaria-trib-mono-tab.component.html',
    styleUrl: './regra-tributaria-trib-mono-tab.component.css',
})
export class RegraTributariaTribMonoTabComponent implements OnInit {
    @Input({ required: true }) form!: FormGroup;
    @Input() formulas: FormulaCatalogoItemStruct[] = [];
    @Input() formulasRetencao: FormulaCatalogoItemStruct[] = [];
    @Input() formulasRetida: FormulaCatalogoItemStruct[] = [];
    @Input() formulasDiferimento: FormulaCatalogoItemStruct[] = [];

    ngOnInit(): void {
        // Campos de cada sub-seção monofásica só são obrigatórios quando o tributo E a sub-seção estão ativos.
        [this.padraoForm, this.retencaoForm, this.retidaAntForm, this.diferimentoForm].forEach(g => {
            g.get('isAtivo')?.valueChanges.subscribe(() => this.sincronizarObrigatoriedade());
        });
        this.ativacaoControl.valueChanges.subscribe(() => this.sincronizarObrigatoriedade());
        this.sincronizarObrigatoriedade();
    }

    private sincronizarObrigatoriedade(): void {
        const ativo = !!this.ativacaoControl.value;
        this.sincronizarSubGrupo(this.padraoForm, ativo, ['adRemIbs', 'adRemCbs']);
        this.sincronizarSubGrupo(this.retencaoForm, ativo, ['adRemIbsReten', 'adRemCbsReten']);
        this.sincronizarSubGrupo(this.retidaAntForm, ativo, ['adRemIbsRet', 'adRemCbsRet']);
        this.sincronizarSubGrupo(this.diferimentoForm, ativo, ['pDifIbs', 'pDifCbs']);
    }

    private sincronizarSubGrupo(grupo: FormGroup, tributoAtivo: boolean, campos: string[]): void {
        const obrigatorio = tributoAtivo && !!grupo.get('isAtivo')?.value;
        campos.forEach(c => this.aplicarObrigatorio(grupo.get(c), obrigatorio));
    }

    private aplicarObrigatorio(control: AbstractControl | null, obrigatorio: boolean): void {
        if (!control) return;
        // Preenchido é não vazio: zero é aceito, negativo não (o teto de 100 dos percentuais vem da máscara).
        if (obrigatorio) {
            control.addValidators([Validators.required, minimoZero]);
        } else {
            control.removeValidators([Validators.required, minimoZero]);
        }
        control.updateValueAndValidity({ emitEvent: false });
    }

    public get monoForm(): FormGroup {
        return this.form.get('mono') as FormGroup;
    }

    public get ativacaoControl(): FormControl {
        return this.monoForm.get('isAtivo') as FormControl;
    }

    public get padraoForm(): FormGroup {
        return this.monoForm.get('padrao') as FormGroup;
    }

    public get retencaoForm(): FormGroup {
        return this.monoForm.get('retencao') as FormGroup;
    }

    public get retidaAntForm(): FormGroup {
        return this.monoForm.get('retidaAnteriormente') as FormGroup;
    }

    public get diferimentoForm(): FormGroup {
        return this.monoForm.get('diferimento') as FormGroup;
    }
}
